import Chapter from "@/components/Chapter";
import Reveal from "@/components/Reveal";
import { TIMELINE } from "@/data/content";

const Timeline = () => (
  <section id="heritage" data-testid="heritage-timeline-section" className="grain-overlay relative bg-navy py-24 md:py-32">
    <div className="mx-auto max-w-7xl px-5 sm:px-8">
      <Chapter
        dark
        index="02"
        eyebrow="Heritage"
        title="Three decades, one discipline."
        description="From the first pit looms in Bhagalpur to fabric shipped across four continents — the milestones that shaped the house."
      />

      <div className="mt-16 space-y-0 border-l border-gold/25 md:ml-24">
        {TIMELINE.map((t, i) => (
          <Reveal key={t.year} delay={i * 0.06}>
            <div data-testid={`timeline-year-${t.year}`} className="group relative grid gap-2 pb-14 pl-10 last:pb-0 md:grid-cols-[120px_1fr] md:gap-8">
              <span className="absolute -left-[5px] top-2 h-2.5 w-2.5 rounded-full bg-gold transition-transform duration-300 group-hover:scale-150" />
              <div className="font-serif text-3xl font-semibold italic text-gold md:-mt-1 md:text-right">{t.year}</div>
              <div>
                <h3 className="font-serif text-xl font-medium text-white sm:text-2xl">{t.title}</h3>
                <p className="mt-2 max-w-xl text-sm leading-relaxed text-slate-400">{t.text}</p>
              </div>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);

export default Timeline;
